<div class="auth-title">
  <h3>{{ "create_account" | translate }}</h3>
  <p>{{ "login_text" | translate }}</p>
</div>
<!-- <app-alert></app-alert> -->
<form class="auth-form-box row" [formGroup]="form" (ngSubmit)="submit()">
  <div class="col-lg-4 col-12 auth-box mb-3 form-box">
    <label for="firstName">First Name</label>
    <input
      type="name"
      class="form-control"
      id="firstName"
      formControlName="firstName"
      placeholder="Enter First Name"
    />
    @if(form.controls['firstName'].touched &&
    form.controls['firstName'].errors?.['required']){
    <div class="invalid-feedback">First name is required.</div>
    }
  </div>

  <div class="col-lg-4 col-12 auth-box mb-3 form-box">
    <label for="lastName">Last Name</label>
    <input
      type="name"
      class="form-control"
      id="lastName"
      formControlName="lastName"
      placeholder="Enter Last Name"
    />
    @if(form.controls['lastName'].touched &&
    form.controls['lastName'].errors?.['required']){
    <div class="invalid-feedback">Last name is required.</div>
    }
  </div>

  <div class="col-lg-4 col-12 auth-box form-box mb-3">
    <label for="email">{{ "email" | translate }}</label>
    <input
      type="text"
      class="form-control"
      id="email"
      placeholder="{{ 'email' | translate }}"
      formControlName="email"
      [autofocus]="false"
    />
    @if(form.controls['email'].touched &&
    form.controls['email'].errors?.['required']){
    <div class="invalid-feedback">
      {{ "email_is_required" | translate }}
    </div>
    } @if(form.controls['email'].touched &&
    form.controls['email'].errors?.['email']){
    <div class="invalid-feedback">
      {{ "invalid_email" | translate }}
    </div>
    }
  </div>

  <div class="col-lg-6 col-12 phone-field mb-3">
    <div class="form-box">
      <label class="form-label" for="address1">{{
        "phone_number" | translate
      }}</label>
      <select2
        class="custom-select intl-tel-input"
        [templates]="template"
        [data]="codes"
        formControlName="country_code"
      >
        <ng-template #template let-data="data">
          <div class="country">
            <div class="flag-box">
              <div class="iti-flag {{ data?.class }}"></div>
            </div>
            <span class="dial-code">{{ data.code }}</span>
          </div>
        </ng-template>
      </select2>
      <input
        type="number"
        class="form-control intl-input-padding"
        formControlName="phone"
        placeholder="Enter Phone No"
        name="phone"
      />
      @if(form.controls['phone'].touched &&
      form.controls['phone'].errors?.['required']){
      <div class="invalid-feedback">
        {{ "phone_number_is_required" | translate }}
      </div>
      } @if(form.controls['phone'].touched &&
      form.controls['phone'].errors?.['pattern']){
      <div class="invalid-feedback">
        {{ "phone_number_is_invalid" | translate }}
      </div>
      }
    </div>
  </div>

  <div class="col-lg-6 col-12 auth-box form-box mb-3">
    <label for="country">Country</label>
    <select2
      class="custom-select"
      [data]="countryList"
      [placeholder]="'Select Country'"
      formControlName="countryId"
      [customSearchEnabled]="true"
      [noResultMessage]="'No Data Found'"
      (search)="searchDropDown($event,'country')"
      (ngModelChange)="selectCountryState($event,'country')"
      resettable
      >
    </select2>
    @if(form.controls['countryId'].touched &&
    form.controls['countryId'].errors?.['required']){
    <div class="invalid-feedback">
      Country is required.
    </div>
    }
  </div>

  <div class="col-lg-6 col-12 auth-box form-box mb-3">
    <label for="state">State</label>
    <select2
      class="custom-select"
      [data]="stateList"
      [placeholder]="'Select State'"
      formControlName="stateId"
      [customSearchEnabled]="true"
      [noResultMessage]="'No Data Found'"
      (search)="searchDropDown($event,'state')"
      (ngModelChange)="selectCountryState($event,'state')"
      resettable
      >
    </select2>
    @if(form.controls['stateId'].touched &&
    form.controls['stateId'].errors?.['required']){
    <div class="invalid-feedback">
      State is required.
    </div>
    }
  </div>

  <div class="col-lg-6 col-12 auth-box form-box mb-3">
    <label for="city">City</label>
    <select2
      class="custom-select"
      [data]="cityList"
      [placeholder]="'Select City'"
      formControlName="cityId"
      [noResultMessage]="'No Data Found'"
      [customSearchEnabled]="true"
      (search)="searchDropDown($event,'city')"
      resettable
      >
    </select2>
    @if(form.controls['cityId'].touched &&
    form.controls['cityId'].errors?.['required']){
    <div class="invalid-feedback">
      City is required.
    </div>
    }
  </div>

  <div class="col-lg-6 col-12 auth-box form-box mb-3">
    <label for="pin">{{ "pin" | translate }}</label>
    <div class="otp-input d-flex">
      <input
        type="text"
        class="form-control"
        maxlength="1"
        formControlName="pin1"
        (input)="onPinChange(1, $event)"
        (keydown)="onPinKeyDown(1, $event)"
      />
      <input
        type="text"
        class="form-control"
        maxlength="1"
        formControlName="pin2"
        (input)="onPinChange(2, $event)"
        (keydown)="onPinKeyDown(2, $event)"
      />
      <input
        type="text"
        class="form-control"
        maxlength="1"
        formControlName="pin3"
        (input)="onPinChange(3, $event)"
        (keydown)="onPinKeyDown(3, $event)"
      />
      <input
        type="text"
        class="form-control"
        maxlength="1"
        formControlName="pin4"
        (input)="onPinChange(4, $event)"
        (keydown)="onPinKeyDown(4, $event)"
      />
      <input
        type="text"
        class="form-control"
        maxlength="1"
        formControlName="pin5"
        (input)="onPinChange(5, $event)"
        (keydown)="onPinKeyDown(5, $event)"
      />
      <input
        type="text"
        class="form-control"
        maxlength="1"
        formControlName="pin6"
        (input)="onPinChange(6, $event)"
        (keydown)="onPinKeyDown(6, $event)"
      />
    </div>
    @if(pinLengthError && form.controls['pin1'].touched){
      <div class="invalid-feedback">
        {{ 'pin_must_be_6_digits' | translate }}
      </div>
    }
  </div>

  <div class="col-lg-6 col-12 auth-box form-box mb-3">
      <label for="email">{{ "confirm_pin" | translate }}</label>
      <div class="otp-input d-flex">
        <input
          type="text"
          class="form-control"
          maxlength="1"
          formControlName="pinConfirmation1"
          (input)="onPinConfirmationChange(1, $event)"
          (keydown)="onPinKeyConfirmationDown(1, $event)"
        />
        <input
          type="text"
          class="form-control"
          maxlength="1"
          formControlName="pinConfirmation2"
          (input)="onPinConfirmationChange(2, $event)"
          (keydown)="onPinKeyConfirmationDown(2, $event)"
        />
        <input
          type="text"
          class="form-control"
          maxlength="1"
          formControlName="pinConfirmation3"
          (input)="onPinConfirmationChange(3, $event)"
          (keydown)="onPinKeyConfirmationDown(3, $event)"
        />
        <input
          type="text"
          class="form-control"
          maxlength="1"
          formControlName="pinConfirmation4"
          (input)="onPinConfirmationChange(4, $event)"
          (keydown)="onPinKeyConfirmationDown(4, $event)"
        />
        <input
          type="text"
          class="form-control"
          maxlength="1"
          formControlName="pinConfirmation5"
          (input)="onPinConfirmationChange(5, $event)"
          (keydown)="onPinKeyConfirmationDown(5, $event)"
        />
        <input
          type="text"
          class="form-control"
          maxlength="1"
          formControlName="pinConfirmation6"
          (input)="onPinConfirmationChange(6, $event)"
          (keydown)="onPinKeyConfirmationDown(6, $event)"
        />
      </div>
      @if(pinMatchError && form.controls['pinConfirmation1'].touched){
      <div class="invalid-feedback">
        {{ "confirm_pin_does_not_matched" | translate }}
      </div>
      }
  </div>

  <div class="auth-box form-box mb-3">
    <div class="forgot-box">
      <div class="form-check ps-0 m-0 custom-check-box">
        <input
          class="checkbox_animated check-box"
          type="checkbox"
          id="flexCheckDefault"
          [formControl]="tnc"
        />
        <label
          class="form-check-label"
          for="flexCheckDefault"
          [class.text-red]="this.tnc.errors?.['required']"
          >{{ "i_agree_with" | translate }}
          <span>{{ "terms" | translate }}</span> {{ "and" | translate }}
          <span>{{ "privacy" | translate }}</span></label
        >
      </div>
    </div>
  </div>
  <app-button
    [class]="'btn'"
    [id]="'sign_up_btn'"
    [disabled]="tnc.invalid || form.invalid"
    [spinner]="true"
    >{{ "create_account" | translate }}</app-button
  >
</form>
<div class="divider">
  <span>{{ "or" | translate }}</span>
</div>
<p class="create">
  {{ "have_account" | translate }}?
  <a href="javascript:void(0)" (click)="action('login')">{{
    "login_here" | translate
  }}</a>
</p>
